<template>
  <div class="p-4 w-full">
    <div v-if="parsedTimeline" class="mx-auto lg:h-20 w-full">
      <div
        class="flex items-center flex-col lg:flex-row lg:flex-1"
      >
        <div
          class="items-center flex flex-col lg:flex-row -ml-40 lg:ml-0 lg:flex-1"
        >
          <div
            class="flex items-center p-1 rounded-full w-8 h-8 justify-center z-10 relative"
            :class="parsedTimeline.first.style.circle"
          >
            <svg
              v-if="parsedTimeline.first.icon === 'check'"
              xmlns="http://www.w3.org/2000/svg"
              class="text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <svg
              v-if="parsedTimeline.first.icon === 'error'"
              xmlns="http://www.w3.org/2000/svg"
              class="text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            <div
              class="whitespace-nowrap flex flex-col items-start font-normal text-sm absolute lg:mt-20 left-full pl-2 lg:-ml-10"
            >
              <div>
                <p
                  class="text-lg font-bold capitalize"
                  :class="parsedTimeline.first.style.text"
                > {{ parsedTimeline.first.text }}</p>
              </div>
              <div v-if="parsedTimeline.first.subText" class="text-gray-600 whitespace-nowrap">{{ parsedTimeline.first.subText }}</div>
            </div>
          </div>
          <div 
            class="bg-gray-200 z-0 w-2 lg:w-full h-16 -my-2 lg:h-2 lg:-mx-2"
          >
            <div class="rounded-full w-full h-full" :class="parsedTimeline.middle.style.line"></div>
          </div>
        </div>
        <div
          class="items-center flex flex-col lg:flex-row -ml-40 lg:ml-0 lg:flex-1"
        >
          <div
            class="flex items-center p-1 rounded-full w-8 h-8 justify-center z-10 relative"
            :class="parsedTimeline.middle.style.circle"
          >
            <svg
              v-if="parsedTimeline.middle.icon === 'check'"
              xmlns="http://www.w3.org/2000/svg"
              class="text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <svg
              v-if="parsedTimeline.middle.icon === 'error'"
              xmlns="http://www.w3.org/2000/svg"
              class="text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            <div
              class="whitespace-nowrap flex flex-col items-start lg:items-center font-normal text-sm absolute lg:mt-20 left-full lg:-left-full pl-2 lg:-right-full"
            >
              <div>
                <p class="text-lg font-bold capitalize" :class="parsedTimeline.middle.style.text">
                  {{ parsedTimeline.middle.text }}
                </p>
              </div>
              <div v-if="parsedTimeline.middle.subText" class="text-gray-600 whitespace-nowrap">{{ parsedTimeline.middle.subText }}</div>
            </div>
          </div>
          <div 
            class="bg-gray-200 z-0 w-2 lg:w-full h-16 -my-2 lg:h-2 lg:-mx-2"
          >
            <div class="rounded-full w-full h-full" :class="parsedTimeline.last.style.line"></div>
          </div>
        </div>
        <div
          class="items-center flex flex-col lg:flex-row -ml-40 lg:ml-0 "
        >
          <div
            class="flex items-center p-1 rounded-full w-8 h-8 justify-center z-10 relative"
            :class="parsedTimeline.last.style.circle"
          >
            <svg
              v-if="parsedTimeline.last.icon === 'check'"
              xmlns="http://www.w3.org/2000/svg"
              class="text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
            <svg
              v-if="parsedTimeline.last.icon === 'error'"
              xmlns="http://www.w3.org/2000/svg"
              class="text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
            <div
              class="whitespace-nowrap flex flex-col items-start lg:items-end font-normal text-sm absolute lg:mt-20 left-full lg:right-full pl-2 lg:-ml-10"
            >
              <div>
                <p class="text-lg font-bold capitalize" :class="parsedTimeline.last.style.text">
                  {{ parsedTimeline.last.text }}
                </p>
              </div>
              <div v-if="parsedTimeline.last.subText" class="text-gray-600 whitespace-nowrap">{{ parsedTimeline.last.subText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  CANCELED,
  FINISHED
} from '@/enum/enum.cluster.status'
export default {
  name: 'SimpleTimeLine',

  props: {
    timeline: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      parsedTimeline: null,
      ERROR_STATUS: [PAYMENT_NOT_APPROVED, CANCELED, PAYMENT_REPROVED],
      FIRST_STEPS: [PAYMENT_PENDING],
      LAST_STEPS: [CANCELED, FINISHED]
    }
  },

  created () {
    this.init()
  },

  methods: {
    init () {
      this.parsedTimeline = this.parseTimeline(this.timeline)
    },

    parseTimeline (timelineMos) {
      if (!timelineMos || !timelineMos.statuses) return null

      const hasError = this.getErrorStatusFromTimeline(this.ERROR_STATUS, timelineMos.statuses)

      const simpleTimeline = this.getSimpleTimeline(this.FIRST_STEPS, this.LAST_STEPS, timelineMos.statuses)

      const parsedTimeline = this.buildParsedTimeline(hasError, simpleTimeline)

      return parsedTimeline
    },

    getErrorStatusFromTimeline (errorStatus, timeline) {
      let hasError = false

      for (const element of timeline) {
        hasError = element.list.some(status => errorStatus.includes(status.cluster.toUpperCase()))
        if (hasError) {
          return hasError
        }
      }

      return hasError
    },

    getSimpleTimeline (firstSteps, lastSteps, timeline) {
      const steps = {
        first: null,
        middle: null,
        last: null
      }
      timeline.forEach(status => {
        for (const item of status.list) {
          if (firstSteps.includes(item.cluster.toUpperCase())) {
            steps.first = item
          } else if (lastSteps.includes(item.cluster.toUpperCase())) {
            steps.last = item
          } else {
            steps.middle = item
          }
        }
      })
      if (!steps.first && steps.last) {
        steps.first = steps.last
        steps.last = null
      }
      if (!steps.middle && steps.last) {
        steps.middle = steps.last
        steps.last = null
      }
      return steps
    },

    buildParsedTimeline (hasError, timeline) {
      const bg = hasError ? 'bg-red-mobly' : 'bg-green-mobly'
      const text = hasError ? 'text-red-mobly' : 'text-green-mobly'
      const icon = hasError ? 'error' : 'check'
      const ruler = {
        first: {
          text: 'Pedido realizado',
          subText: null,
          default: true,
          icon: icon,
          style: {
            circle: bg,
            text: text
          }
        },
        middle: {
          text: 'Produto em transporte',
          subText: null,
          default: true,
          icon: 'default',
          style: {
            line: 'bg-gray-400',
            circle: 'bg-gray-400',
            text: 'text-gray-600'
          }
        },
        last: {
          text: 'Entregue',
          subText: null,
          default: true,
          style: {
            line: 'bg-gray-400',
            circle: 'bg-gray-400',
            text: 'text-gray-600'
          }
        },
      }
      if (timeline.first) {
        const dateTimeChunks = new Date(timeline.first.event_date).toLocaleString('pt-BR', { hour12: false }).split(' ')
        const timeChunks = dateTimeChunks[1].split(':')
        timeChunks.splice(timeChunks.length - 1, 1)
        const date = dateTimeChunks[0]
        const time = timeChunks.join(':')
        ruler.first.text = timeline.first.resumido
        ruler.first.subText = `${date} às ${time}`
      }
      if (timeline.middle) {
        const dateTimeChunks = new Date(timeline.middle.event_date).toLocaleString('pt-BR', { hour12: false }).split(' ')
        const timeChunks = dateTimeChunks[1].split(':')
        timeChunks.splice(timeChunks.length - 1, 1)
        const date = dateTimeChunks[0]
        const time = timeChunks.join(':')
        ruler.middle.text = timeline.middle.resumido
        ruler.middle.subText = `${date} às ${time}`
        ruler.middle.icon = icon
        ruler.middle.style.line = bg
        ruler.middle.style.circle = bg
        ruler.middle.style.text = text
      }
      if (timeline.last) {
        const dateTimeChunks = new Date(timeline.last.event_date).toLocaleString('pt-BR', { hour12: false }).split(' ')
        const timeChunks = dateTimeChunks[1].split(':')
        timeChunks.splice(timeChunks.length - 1, 1)
        const date = dateTimeChunks[0]
        const time = timeChunks.join(':')
        ruler.last.text = timeline.last.resumido
        ruler.last.subText = `${date} às ${time}`
        ruler.last.icon = icon
        ruler.last.style.line = bg
        ruler.last.style.circle = bg
        ruler.last.style.text = text
      }
      return ruler
    }
  }
}
</script>
